export default __webpack_public_path__ + "static/media/icon-americanexpress-24px.2ddec9df.svg";